import type { paths } from "@/api-schema";
import { alphartisApiAxios } from "@/config/axios";
import { useQuery } from "@tanstack/react-query";
import { optionsWithDefaults } from "../_helpers/options-with-defaults";
import { Options } from "../_types";

export const RELOCATION_ORDER_BY_UUID_RESOURCE = "relocation-order" as const;
export const RELOCATION_ORDER_BY_UUID_API_PATH = `/v1/${RELOCATION_ORDER_BY_UUID_RESOURCE}/{uuid}` as const;

export type RelocationOrderByUuidParameters =
  paths[typeof RELOCATION_ORDER_BY_UUID_API_PATH]["get"]["parameters"]["query"];
export type RelocationOrderByUuidResponse =
  paths[typeof RELOCATION_ORDER_BY_UUID_API_PATH]["get"]["responses"][200]["content"]["application/json"];

export function useRelocationOrderByUuidQuery(uuid: string, options?: Options<RelocationOrderByUuidParameters, never>) {
  const optionsWithDefaultsResolved = optionsWithDefaults<Options<RelocationOrderByUuidParameters, never>>(options);

  const requestParameters = {
    ...(optionsWithDefaultsResolved.parameters || {}),
    extend: optionsWithDefaultsResolved.parameters?.extend || [],
  };

  return useQuery({
    enabled: !!uuid,
    queryKey: [RELOCATION_ORDER_BY_UUID_RESOURCE, uuid, { parameters: requestParameters }],
    queryFn: async () => {
      const response = await alphartisApiAxios.get<RelocationOrderByUuidResponse>(
        `/v1/${RELOCATION_ORDER_BY_UUID_RESOURCE}/${uuid}`,
        {
          params: requestParameters,
        },
      );

      return response.data;
    },
  });
}
